interface ILabel {
  required?: boolean;
  children: string;
  className?: string;
}

export const Label = ({ required, children, className = '' }: ILabel) => (
  <label className={`text-xs font-medium text-gray-400 pl-4 ${required ? 'required' : ''} ${className}`}>{children}</label>
);
